import FormattedMessage from 'I18n/components/FormattedMessage';
import { withRouter } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
// @ts-expect-error migrate upstream
import { connect as connectFlux } from 'general-store';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import UIList from 'UIComponents/list/UIList';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { DashboardFloatingAlertStore } from 'dashboard-components/shared/DashboardFloatingAlertStore';
import { deleteDashboard, updateDashboardMeta, cloneDashboard
// @ts-expect-error migrate upstream
} from '../../../actions/DashboardActions';
import DashboardsDependency, { DashboardCountDependency, CustomReportCountDependency, RefreshingAllDependency
// @ts-expect-error migrate upstream
} from '../../../dependencies/DashboardsDependency';
// @ts-expect-error migrate upstream
import { DefaultDashboardDependency } from '../../../dependencies/DashboardDependency';
import compose from 'transmute/compose';
import { getDemo, getId, getName, getReportWidgetCount
// @ts-expect-error migrate upstream
} from 'dashboard-lib/public/dashboard/dashboard-schema';
// @ts-expect-error migrate upstream
import mapProps from 'dashboard-components/decorator/mapProps';
import { track as dashboardTracker, EVENTS, DashboardUITracker
// @ts-expect-error migrate upstream
} from 'dashboard-ui-components/tracking/DashboardUITracker';
import { useFetchDashboardOnOpen } from '../../../hooks/useFetchDashboardOnOpen';
// @ts-expect-error migrate upstream
import DeleteDashboardButton from 'reporting-action-components/reportingActions/deleteDashboard/DeleteDashboardButton';
// @ts-expect-error migrate upstream
import SetDefaultDashboardButton from 'reporting-action-components/reportingActions/setDefaultDashboard/SetDefaultDashboardButton';
import { setUserAttribute, removeUserAttribute
// @ts-expect-error migrate upstream
} from '../../../actions/SettingsActions';
// @ts-expect-error migrate upstream
import CloneDashboardAction from 'dashboard-components/dashboard-actions/CloneDashboardAction';
import RefreshAllDashboardAction from './RefreshAllDashboardAction';
import { DASHBOARD_IS_LOADING, DASHBOARD_REPORT_LIMIT, MAX_USER_ASSET_PERMISSION, TARGET_DASHBOARD_REPORT_COUNT, TARGET_IS_READ_ONLY_DEMO, USER_DASHBOARD_PERMISSION
// @ts-expect-error migrate upstream
} from 'dashboard-lib/private/action-problem-solution/params/all-params';
// @ts-expect-error migrate upstream
import { hasSufficientEditPermission } from 'dashboard-lib/public/permission/compute-permission';
// @ts-expect-error migrate upstream
import { isReadOnlyDemo as isReadOnlyDemoDashboard } from 'dashboard-lib/public/dashboard/dashboard-logic';
// @ts-expect-error migrate upstream
import { getAddStaticWidgetToDashboardProblem } from 'dashboard-lib/public/enable-action/add-static-widget-to-dashboard';
import { getAddNoteDisabledMessage, getAddIframeDisabledMessage
// @ts-expect-error migrate upstream
} from 'dashboard-components/disabled-message/actions/add-static-widget-to-dashboard';
import store from '../../../stores/ReduxStore';
// @ts-expect-error migrate upstream
import { withDialog } from 'reporting-action-components/dialog/DialogProvider';
// @ts-expect-error migrate upstream
import { VIEW_ACTIVITY_LOG } from 'dashboard-lib/public/action/reporting-action';
// @ts-expect-error migrate upstream
import { getUserPermissionLevel } from 'dashboard-lib/public/dashboard/dashboard-schema';
import { selectHasDashboardDemoWriteScope, selectHasIframeWidgetAccess, selectIsJitaUser
// @ts-expect-error migrate upstream
} from 'dashboard-lib/public/userInfo/scopes';
import { selectCustomReportsLimit, selectDashboardLimit, selectDashboardMaxWidgetsLimit
// @ts-expect-error migrate upstream
} from 'dashboard-lib/public/userInfo/limits';
// @ts-expect-error migrate upstream
import { selectUserMaxAssetPermission } from 'dashboard-lib/public/userInfo/permissions';
// @ts-expect-error migrate upstream
import OwnersDependency from '../../../dependencies/OwnersDependency';
// @ts-expect-error migrate upstream
import { showSuccessNotification } from 'dashboard-components/report-actions/lib/reportActionAlerts';
// @ts-expect-error migrate upstream
import { withUserInfo } from 'dashboard-components/context/user-info-context';
import CreateAssetTemplateButton from 'reporting-action-components/reportingActions/createAssetTemplate/CreateAssetTemplateButton';
import { USER_ATTRIBUTES_KEYS } from '../../../data/UserAttributesDAO';
import DashboardDetailsButton from './DashboardDetailsButton';
import { Routes } from '../../../constants/route/DashboardRoute';
import * as DashboardRouter from '../../../lib/dashboard-router';
import { NOTE_WIDGET_EDIT, IFRAME_WIDGET_EDIT } from '../../../constants/dialogTypes';
// @ts-expect-error migrate upstream
import { useUserRoleForDashboard } from 'reporting-action-components/utils/trackingUtils';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DashboardActionDropdown = ({
  dashboard,
  dashboards,
  history,
  isOwner,
  currentDashboardId,
  defaultDashboardId,
  dashboardsCount,
  allCustomReportCount,
  canWriteDemoDashboard,
  customDashboardLimit,
  customReportLimit,
  isReadOnlyDemo,
  maxUserAssetPermission,
  showDialog,
  owners,
  enterPresentationMode,
  refreshingAll
}) => {
  const dashboardMaxWidgets = useSelector(selectDashboardMaxWidgetsLimit);
  const hasIframeWidgetAccess = useSelector(selectHasIframeWidgetAccess);
  const userDashboardPermission = getUserPermissionLevel(dashboard);
  const isJitaUser = useSelector(selectIsJitaUser);
  const addStaticWidgetProblem = getAddStaticWidgetToDashboardProblem({
    [DASHBOARD_IS_LOADING]: !dashboard,
    [TARGET_IS_READ_ONLY_DEMO]: isReadOnlyDemo,
    [USER_DASHBOARD_PERMISSION]: userDashboardPermission,
    [MAX_USER_ASSET_PERMISSION]: maxUserAssetPermission,
    [DASHBOARD_REPORT_LIMIT]: dashboardMaxWidgets,
    [TARGET_DASHBOARD_REPORT_COUNT]: getReportWidgetCount(dashboard)
  });
  const handleDefaultDashboardChange = isAlreadyDefault => {
    if (isAlreadyDefault) {
      removeUserAttribute(USER_ATTRIBUTES_KEYS.PREFERRED_HOME);
      dashboardTracker(EVENTS.removeDefaultDashboard);
    } else {
      setUserAttribute(USER_ATTRIBUTES_KEYS.PREFERRED_HOME, getId(dashboard));
      dashboardTracker(EVENTS.setDefaultDashboard);
    }
  };
  const renderDemoToggle = () => {
    if (!canWriteDemoDashboard || !isOwner) {
      return null;
    }
    const isDemo = getDemo(dashboard);
    const toggleDemo = () => updateDashboardMeta(dashboard.get('id'), {
      demo: !isDemo
    }).then(showSuccessNotification({
      message: isDemo ? 'dashboard.action.toggleDemo.success.disable' : 'dashboard.action.toggleDemo.success.enable',
      options: {
        dashboardName: getName(dashboard)
      }
    }));
    const labelKey = isDemo ? 'dashboard.action.toggleDemo.disable' : 'dashboard.action.toggleDemo.enable';
    return /*#__PURE__*/_jsx(UIButton, {
      onClick: toggleDemo,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: labelKey
      })
    }, "demo-toggle");
  };
  const renderSetDefaultDashboard = () => /*#__PURE__*/_jsx(SetDefaultDashboardButton, {
    dashboard: dashboard,
    defaultDashboardId: defaultDashboardId,
    onDefaultChange: handleDefaultDashboardChange,
    appUsageTracker: DashboardUITracker
  }, "set-default");
  const renderAddNote = () => {
    const openNoteEditor = () => {
      dashboardTracker(EVENTS.clickNoteAction, {
        actionType: 'edit',
        action: 'create',
        object: 'note',
        assetType: 'dashboard',
        interactionSource: 'actions-dropdown',
        interactionWith: 'asset-action'
      });
      showDialog({
        dialogType: NOTE_WIDGET_EDIT,
        dialogProps: {
          dashboardId: currentDashboardId
        }
      });
    };
    const AddNoteDisabledMessage = getAddNoteDisabledMessage({
      [DASHBOARD_REPORT_LIMIT]: dashboardMaxWidgets
    }, addStaticWidgetProblem);
    return /*#__PURE__*/_jsx(UITooltip, {
      disabled: !AddNoteDisabledMessage,
      title: AddNoteDisabledMessage && /*#__PURE__*/_jsx(AddNoteDisabledMessage, {}),
      children: /*#__PURE__*/_jsx(UIButton, {
        onClick: openNoteEditor,
        use: "link",
        disabled: !!AddNoteDisabledMessage,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dashboard.action.addNote"
        })
      }, "add-note")
    });
  };
  const renderAddIframe = () => {
    if (!hasIframeWidgetAccess) {
      return null;
    }
    const openIframeEditor = () => {
      dashboardTracker(EVENTS.clickIframeAction, {
        actionType: 'edit',
        action: 'create',
        object: 'iframe',
        assetType: 'dashboard',
        interactionSource: 'actions-dropdown',
        interactionWith: 'asset-action'
      });
      showDialog({
        dialogType: IFRAME_WIDGET_EDIT,
        dialogProps: {
          dashboardId: currentDashboardId
        }
      });
    };
    const AddIframeDisabledMessage = getAddIframeDisabledMessage({
      [DASHBOARD_REPORT_LIMIT]: dashboardMaxWidgets
    }, addStaticWidgetProblem);
    return /*#__PURE__*/_jsx(UITooltip, {
      disabled: !AddIframeDisabledMessage,
      title: AddIframeDisabledMessage && /*#__PURE__*/_jsx(AddIframeDisabledMessage, {}),
      children: /*#__PURE__*/_jsx(UIButton, {
        onClick: openIframeEditor,
        use: "link",
        disabled: !!AddIframeDisabledMessage,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dashboard.action.addIframe"
        })
      }, "add-iframe")
    });
  };
  const userRole = useUserRoleForDashboard(dashboard);
  const renderCloneDashboard = () => /*#__PURE__*/_jsx(CloneDashboardAction, {
    customDashboardCount: dashboardsCount,
    customDashboardLimit: customDashboardLimit,
    customReportCount: allCustomReportCount,
    customReportLimit: customReportLimit,
    dashboard: dashboard,
    isDashboardFetched: dashboards.getIn(['dashboardFetched', currentDashboardId]),
    dashboardFetchFailed: dashboards.getIn(['dashboardFetchFailed', currentDashboardId]),
    maxUserAssetPermission: maxUserAssetPermission,
    onClone: (name, options, parentDashboard, shouldCloneReports) => cloneDashboard(name, options, parentDashboard, history, shouldCloneReports),
    trackClick: () => {
      dashboardTracker(EVENTS.clickCloneAction, {
        actionType: 'create',
        action: 'create',
        step: 'start',
        assetType: 'dashboard',
        role: userRole
      });
    },
    trackAction: ({
      shouldCloneReports
    }) => dashboardTracker(EVENTS.cloneDashboard, {
      option: shouldCloneReports ? 'clone-reports' : 'link-reports'
    }),
    store: store,
    showDialog: showDialog
  }, "clone");
  const renderDeleteDashboard = () => /*#__PURE__*/_jsx(DeleteDashboardButton, {
    dashboard: dashboard,
    appUsageTracker: DashboardUITracker,
    onDelete: (dashboardIds, deleteReports) => {
      const dashboardId = dashboardIds.first();
      const keepReport = !deleteReports;
      return deleteDashboard(dashboardId, {
        keepReport
      }).then(() => {
        DashboardRouter.route(Routes.DASHBOARD, undefined, undefined, history);
      });
    },
    trackClick: () => dashboardTracker(EVENTS.clickDeleteAction, {
      actionType: 'edit',
      action: 'delete',
      step: 'start',
      assetType: 'dashboard',
      role: userRole
    }),
    trackAction: () => dashboardTracker(EVENTS.deleteDashboard, {
      subscreen: 'dashboard'
    })
  }, "delete");
  const renderPresentationMode = () => /*#__PURE__*/_jsx(UIButton, {
    use: "link",
    onClick: () => {
      dashboardTracker(EVENTS.clickFullScreenMode);
      enterPresentationMode();
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.action.presentationMode"
    })
  }, "presentationMode");
  const hasActivityLogAccess = hasSufficientEditPermission(userDashboardPermission) || isJitaUser;
  const renderActivityLog = () => !hasActivityLogAccess ? null : /*#__PURE__*/_jsx(UIButton, {
    use: "link",
    onClick: () => {
      dashboardTracker(EVENTS.clickActivityLog);
      showDialog({
        dialogType: VIEW_ACTIVITY_LOG,
        dialogProps: {
          dashboardId: currentDashboardId,
          dashboard,
          usersById: owners.get('remotes')
        }
      });
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.action.activityLog"
    })
  }, "activityLog");
  const renderRefreshAll = () => /*#__PURE__*/_jsx(RefreshAllDashboardAction, {
    dashboard: dashboard,
    disabled: refreshingAll
  });
  const handleDropdownOpenChange = useFetchDashboardOnOpen({
    dashboards,
    dashboardId: currentDashboardId
  });
  return !dashboard ? null : /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FloatingAlertList, {
      alertStore: DashboardFloatingAlertStore
    }), /*#__PURE__*/_jsx(UIDropdown, {
      buttonSize: "sm",
      buttonUse: "secondary",
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.action.actions"
      }),
      closeOnMenuClick: true,
      placement: "bottom left",
      onOpenChange: handleDropdownOpenChange,
      "data-test-id": "dashboard-action-dropdown",
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [renderDemoToggle(), /*#__PURE__*/_jsx(CreateAssetTemplateButton, {
          assetType: "dashboard",
          assetId: Number(currentDashboardId)
        }), renderAddNote(), renderAddIframe(), renderCloneDashboard(), /*#__PURE__*/_jsx(DashboardDetailsButton, {
          dashboard: dashboard
        }), renderActivityLog(), renderPresentationMode(), renderRefreshAll(), /*#__PURE__*/_jsx(UIDropdownDivider, {}), renderSetDefaultDashboard(), renderDeleteDashboard()]
      })
    }, "settings")]
  });
};
export default compose(withDialog, connectFlux({
  dashboards: DashboardsDependency,
  defaultDashboardId: DefaultDashboardDependency,
  dashboardsCount: DashboardCountDependency,
  allCustomReportCount: CustomReportCountDependency,
  owners: OwnersDependency,
  refreshingAll: RefreshingAllDependency
}), withUserInfo, connect(state => {
  return {
    canWriteDemoDashboard: selectHasDashboardDemoWriteScope(state),
    customDashboardLimit: selectDashboardLimit(state),
    customReportLimit: selectCustomReportsLimit(state),
    maxUserAssetPermission: selectUserMaxAssetPermission(state)
  };
}), mapProps(props => {
  const {
    canWriteDemoDashboard,
    customDashboardLimit,
    dashboard,
    allCustomReportCount
  } = props;
  const isReadOnlyDemo = isReadOnlyDemoDashboard(canWriteDemoDashboard, dashboard);
  return Object.assign({
    customDashboardLimit,
    isReadOnlyDemo,
    allCustomReportCount
  }, props);
}), withRouter)(DashboardActionDropdown);